import { useEffect } from 'react';
import { useFormik } from 'formik';
import { Box } from '@mui/material';

import { Drawer, drawerType } from '../../../../packages/ui/organisms/drawer';
import {
  btnType,
  Button,
  Checkbox,
  fontWeight,
  FormControlLabel,
  Heading,
  headingLevel,
  IconButton,
  Input,
  inputSize,
  Text,
  TextError,
} from '../../../../packages';
import { AddStateSchema } from './AddStateDrawer.schema';
import { useStyles } from './AddStateDrawer.styles';

const AddStateDrawer = ({ isOpen, selectedState, onSubmit, onClose }) => {
  const classes = useStyles();

  const defaultValues = {
    name: selectedState?.state.name || '',
    displayName: selectedState?.state.displayName || '',
    isActive: selectedState?.state.isActive || false,
  };

  const { errors, values, handleChange, handleSubmit, touched, setFieldValue, ...rest } = useFormik({
    initialValues: defaultValues,
    enableReinitialize: true,
    validationSchema: AddStateSchema,
    onSubmit: payload => {
      onSubmit(payload);
    },
  });

  const setTouched = name => async () => {
    await rest.setTouched({ ...touched, [name]: true });
  };

  useEffect(() => {
    if (!isOpen) {
      rest.handleReset({ ...defaultValues });
      rest.setErrors({});
    }
  }, [isOpen]);

  const renderLabel = label => (
    <Heading level={headingLevel.S} className={classes.label} weight={fontWeight.BOLD}>
      {label}
    </Heading>
  );

  return (
    <Drawer open={isOpen} onClose={onClose} variant={drawerType.NORMAL} className={classes.drawer}>
      <Box className={classes.wrapper}>
        <Box className={classes.header}>
          <Text className={classes.headerTitle}>{selectedState ? 'Edit' : 'Add'} State</Text>
          <IconButton icon="close" onClick={onClose} className={classes.backBtn} />
        </Box>
        <form className={classes.form} onSubmit={handleSubmit}>
          <Box className={classes.formContent}>
            <Box className={classes.section}>
              {renderLabel('State Name')}
              <Input
                fullWidth
                name="name"
                value={values.name}
                placeholder="Enter a state name"
                size={inputSize.M}
                onBlur={setTouched('name')}
                onChange={handleChange}
                disabled
              />
              <TextError errorMsg={touched.name ? errors.name : null} />
            </Box>
            <Box className={classes.section}>
              {renderLabel('Display Name')}
              <Input
                fullWidth
                name="displayName"
                value={values.displayName}
                placeholder="Enter a display name"
                size={inputSize.M}
                onBlur={setTouched('displayName')}
                onChange={handleChange}
                disabled
              />
              <TextError errorMsg={touched.displayName ? errors.displayName : null} />
            </Box>
            <Box className={classes.section}>
              {renderLabel('Status')}
              <FormControlLabel
                control={<Checkbox />}
                checked={values.isActive}
                name="isActive"
                onChange={() => {
                  void setFieldValue('isActive', !values.isActive);
                }}
                label="Active"
              />
              <TextError errorMsg={touched.isActive ? errors.isActive : null} />
            </Box>
          </Box>
          <Box className={classes.footer}>
            <Button variant={btnType.TEXT} onClick={onClose}>
              Cancel
            </Button>
            <Button onClick={handleSubmit}>Save</Button>
          </Box>
        </form>
      </Box>
    </Drawer>
  );
};

export { AddStateDrawer };
